import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterRoles'
})
export class FilterRolesPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if(!items) return [];
    if(!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter( it => {
    return it.role_name.toLowerCase().includes(searchText);
    });
   }

}
